module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bak-color mb-10"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "blocks_sec col-xs-12"
  }, [_c('div', {
    staticClass: "news_blocks ol-xs-12"
  }, [_c('div', {
    staticClass: "news_block "
  }, [_c('div', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.fetchedData), function(data) {
    return _c('li', {
      staticClass: "news-section"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_c('img', {
      attrs: {
        "src": data.attributes.medium_image,
        "alt": "data.attributes.title",
        "width": "80",
        "height": "80"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "news_in col-lg-9 col-md-8 col-sm-9 col-xs-8"
    }, [_c('p', {
      staticClass: "para-text"
    }, [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_vm._v(_vm._s(data.attributes.title))])], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("convertDate")(data.attributes.event_date))), _c('em', [_vm._v(_vm._s(data.attributes.published_by))])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "col-md-6"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.fetchedNews), function(data) {
    return _c('li', {
      staticClass: "news-section"
    }, [_c('span', [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_c('img', {
      attrs: {
        "src": data.attributes.medium_image,
        "alt": "data.attributes.title",
        "width": "80",
        "height": "80"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "news_in col-lg-9 col-md-8 col-sm-9 col-xs-8"
    }, [_c('p', {
      staticClass: "para-text"
    }, [_c('router-link', {
      attrs: {
        "to": '/blog/' + data.attributes.slug
      }
    }, [_vm._v(_vm._s(data.attributes.title))])], 1), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("convertDate")(data.attributes.event_date))), _c('em', [_vm._v(_vm._s(data.attributes.published_by))])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("Article")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("News")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebdaef40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Category.vue
// module id = 315
// module chunks = 1